export default "__VITE_ASSET__Btt14YPZ__"